import PropTypes from "prop-types";
import "./ui.css";

// Status → tag tone. "Done" states are navy (the palette has no green);
// waiting states gold; finished/inactive neutral; failures red.
const TONES = {
  brand: ["active", "approved", "verified", "enabled", "computed", "finished", "completed"],
  accent: ["pending", "draft", "in progress", "ready", "processing", "moderation"],
  neutral: ["closed", "inactive", "disabled", "new", "added", "lock", "locked"],
  danger: ["rejected", "deleted", "cancelled", "canceled", "banned", "failed", "error"],
};

const toneOf = (value) => {
  const v = String(value).trim().toLowerCase();
  return Object.keys(TONES).find((tone) => TONES[tone].includes(v)) || "neutral";
};

export default function StatusTag({ value }) {
  if (value === null || value === undefined || value === "" || value === "-") return value ?? null;
  const tone = toneOf(value);
  return <span className={`simcc-tag${tone === "brand" ? "" : ` simcc-tag--${tone}`}`}>{value}</span>;
}

StatusTag.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

StatusTag.defaultProps = {
  value: undefined,
};
